import React, { useState } from "react";
import { Form } from "react-final-form";
import Button from "@mui/material/Button";
import FormTextField from "@Components/forms/formFields/textField/FormTextField";
import { validEmail } from "@Components/forms/helpers/FieldValidator";
import { withAsync } from "@Libs/api/withAsync";
import { newsletterSubscriptionEvent } from "@Libs/dynamic-yield/trackingEvents";
import { SnackBarType } from "@Types/SnackBar";
import { nextAppEnv } from "@Utils/environment";
import { triggerSnackBar } from "@wff/store/SnackBarSlice";
import { useAppDispatch } from "store/hooks";
import { subscribeToKlaviyoList } from "../../api/customerApi";
import footerClasses from "../../styles/snippets/_footer.module.scss";
import footerNewsletterClasses from "../../styles/snippets/_footer__newsletter.module.scss";
import classes from "./email-subscription.module.scss";

interface IEmailSubscribeProps {
  emailSignupTitle: string;
  emailSignupCaption: string;
  emailSignupTextBoxPlaceholder: string;
  emailSignupButtonLabel: string;
}

export function EmailSubscribeBox(props: IEmailSubscribeProps) {
  const {
    emailSignupTitle,
    emailSignupCaption,
    emailSignupTextBoxPlaceholder,
    emailSignupButtonLabel,
  } = props;
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const sizzleListId = nextAppEnv.klaviyo.newsletterListId || "Tt7vv3";

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
  };
  const handleClickSignUp = async () => {
    const payload = {
      profiles: [
        {
          email: email,
        },
      ],
    };
    const listId = sizzleListId;
    const { error, response } = await withAsync(() =>
      subscribeToKlaviyoList(listId, payload)
    );
    const success = !error && response?.status === 200;
    if (success) {
      // Track `Newsletter Subscription` Event for DY
      newsletterSubscriptionEvent(email);
    }
    setConfirmation(success);
    const snackBarData = {
      message: success
        ? "Succesfully subscribed to sizzle list"
        : "Failed to subscribe to sizzle list",
      type: success ? SnackBarType.SUCCESS : SnackBarType.ERROR,
    };
    dispatch(triggerSnackBar(snackBarData));
  };

  return (
    <section className={footerClasses["site-footer__newsletter"]}>
      <div className={footerNewsletterClasses.newsletter__content}>
        <Form
          onSubmit={handleClickSignUp}
          render={(props) => {
            return (
              <>
                <div className={footerNewsletterClasses.newsletter}>
                  <h2 className={footerNewsletterClasses.newsletter__title}>
                    {emailSignupTitle}
                  </h2>
                  <p>{emailSignupCaption}</p>
                </div>
                {!confirmation ? (
                  <div className={classes["email-wrapper"]}>
                    <form
                      id="email_subscribe-box"
                      aria-label="address form"
                      onSubmit={props.handleSubmit}
                      className={classes["email-wrapper-form"]}
                    >
                      <FormTextField
                        name="email"
                        onChange={handleChangeEmail}
                        data-testid="email-box"
                        label={emailSignupTextBoxPlaceholder}
                        showToolTip={false}
                      />

                      <Button
                        id="email-subscribe-button"
                        variant="contained"
                        type="submit"
                        disabled={!validEmail(email)}
                      >
                        {emailSignupButtonLabel}
                      </Button>
                    </form>
                  </div>
                ) : (
                  <div>
                    <div className={classes["confirmation-title"]}>
                      Thanks for subscribing!
                    </div>
                    <div className={classes["confirmation-message"]}>
                      Check your email for a confirmation message.
                    </div>
                  </div>
                )}
              </>
            );
          }}
        />
      </div>
    </section>
  );
}

EmailSubscribeBox.defaultProps = {
  emailSignupTitle: "",
  emailSignupCaption: "",
  emailSignupTextBoxPlaceholder: "",
  emailSignupButtonLabel: "",
};

export default EmailSubscribeBox;
